<template>
    <template v-if="!headersLoaded && !moduleLocked">
        <Loader />
    </template>
    <EmptyState v-else-if="moduleLocked" :icon="'event'" :title="'Este contenido no se encuentra disponible aún'" :message="`<span>Podrás visualizarlo a partir del <strong>${moduleLockedDate}</strong><br>Si quieres ver más material, te invitamos a que recorras los distintos artículos, podcast y charlas que hemos seleccionado para ti en la sección <a href=/resources style=color:#9E5498;font-weight:600;>Recursos</a></span>`" :color="'pink'"/>
    <div v-else class="headers-container">
        <div v-if="route.query.redirect" class="back-route" @click="router.back()"><i class="material-icons">keyboard_arrow_left</i>Volver</div>
        <div v-else class="back-route" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}`)"><i class="material-icons">keyboard_arrow_left</i><span>Volver al módulo</span></div>

        <h2>{{ $t('course.modules.forum.TITLE') }}</h2>

        <div class="content">
            <template v-if="contentLoaded">
                <div v-html="content.data.Data"></div>
            </template>
            <Loader v-else/>
        </div>

        <!-- TUTOR DATA -->
        <div class="tutor-view" v-if="user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
            <template v-if="resumeLoaded">
                <div class="resume">
                    <div class="title" @click.stop="resume.expand ? resume.expand = false : resume.expand = true">
                        <span>{{$t('global.RESUME')}}</span>
                        <i class="material-icons">{{resume.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
                    </div>
                    <div class="resume-data" v-if="resume.expand">
                        <div>{{ $t('global.PARTICIPANTS') }}   <span>{{resume.totalStudents}}</span></div>
                        <div>{{$t('global.TOTAL_DELIVERED')}}   <span>{{resume.finished}}</span></div>
                        <div>{{ $t('global.DELIVERY_DATE')}}   <span>{{formatDate(resume.endDate)}}</span></div>
                        <div>{{ $t('global.ACTIVITY_STATUS')}} 
                            <span v-if="resume.remainingTimeValue" style="color:#009696" >Abierta</span>
                            <span v-else style="color:#F57055">Vencida</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="detailLoaded && user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
            <div class="detail">
                <div class="title">
                    <div class="title__span" @click.stop="detail.expand = !detail.expand" >
                        <span>{{$t('global.DETAIL')}}</span>
                        <i class="material-icons">{{detail.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
                    </div>
                    <div v-show="detail.expand" class="details__filter" >
                          <div  class="dropdown" ref="status">
                            <input type="checkbox" id="status">
                            <label class="dropdown__face" for="status">
                                <div class="dropdown__text">{{$t('global.STATE')}}</div>
                                <span class="material-icons">keyboard_arrow_down</span>
                            </label>
                            <ul class="dropdown__items">
                                <template v-for="(state,index) in statusFilters.status" :key="index" >
                                    <li :style="{ 'color': statusFilters.selected === state ? '#000' : '#7D7D7D' }" @click.stop="addStateFilter(state)" >{{ $t(`tutor.detail.status.${state}`) }}</li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="detail-data" v-if="detail.expand">
                        <div class="table-title">{{$t('global.PARTICIPANT')}}</div>
                        <div class="table-title">{{$t('global.STATUS')}}</div>
                        <div class="table-title">{{$t('global.LAST_MODIFICATION')}}</div>
                        <template v-if="detailValuesLoaded" >
                            <template v-for="(student,index) in detail.data" :key="index">
                                    <div class="table-user" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${route.params.contentId}/userHistory/${student.learningUserId}`)">
                                        {{student.firstName}} {{student.lastName}}
                                    </div>
                                    <div class="detail__status">
                                        <span :class="{'NotFinished--a': student.status == 'NotFinished', 'FinishedOutOfTime--a': student.status === 'FinishedOutOfTime', 'FinishedInTime--a': student.status === 'FinishedInTime'}">
                                            {{$t(`tutor.detail.status.${student.status}`)}}
                                        </span>
                                        <span v-if="student.status == 'NotFinished'">
                                            {{student.timeDiffValue ? $t('global.EXPIRES_IN') + student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) : $t('global.EXPIRED')}}
                                        </span>
                                        <span v-if="student.status == 'FinishedOutOfTime'">
                                            {{student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) + ' ' + $t('global.LATE')}}
                                        </span>
                                    </div> 
                                    <div>{{student.lastSeen ? formatDate(student.lastSeen) : $t('global.NEVER')}}</div>
                            </template>
                        </template>
                    </div>
                </div>
            </template>
        </div>

        <!-- HILOS DE DEBATE -->
        <template v-if="headersLoaded">
            <template v-if="headers.length">
                <div class="select-header">
                    <div class="title title-topic">{{$t('forum.tutorView.TOPIC_OF_DISCUSSION')}}</div>
                    <div class="title title-startedBy">{{$t('forum.tutorView.CREATED_BY')}}</div>
                    <div class="title title-lastPost">{{$t('forum.tutorView.LAST_ANSWER')}}</div>
                    <div class="title title-replies">{{$t('forum.tutorView.NUMBER_OF_RESPONSES')}}</div>
                    <div></div>
    
                    <template v-for="(header, index) in headers" :key="index">
                        <div class="item item-topic">
                            <span @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${route.params.contentId}/${header.id}`)">{{header.subject}}</span>
                        </div>
                        <div class="item item-startedBy"><span>{{header.startedBy}}</span><span>{{formatDate(header.startDate)}}</span></div>
                        <div class="item item-lastPost">
                            <template v-if="header.lastPostBy">
                                <span>{{header.lastPostBy}}</span><span>{{formatDate(header.lastPostDate)}}</span>
                            </template>
                            <span v-else>-</span>
                        </div>
                        <div class="item item-replies">{{header.replies}}</div>
                        <div class="item item-edit"><i class="material-icons" @click.stop="headerEditMode(header)">edit</i></div>
                    </template>
                </div>
            </template>
            <EmptyState v-else-if="user.role.toLowerCase() === 'learninguser'" icon="comments_disabled" :title="$t('forum.emptyState.TITLE')" :message="$t('forum.emptyState.MESSAGE')"/>
            <EmptyState v-else icon="insert_comment" :title="$t('forum.emptyState.TITLE')" :message="$t('forum.emptyState.TUTOR_MESSAGE')" :color="'pink'" />
        </template>
        <div v-else>Cargando temas de debate...</div>

        <!-- TUTOR - NUEVO TEMA DE DEBATE -->
        <template v-if="headersLoaded">
            <div class="new-header" v-if="user.permissions.includes('CURSO_FORO_TEMA_DEBATE') && headers.length === 0 || editingHeader">
                <button class="btn-create-header" v-if="!creatingHeader" @click.stop="creatingHeader = true;">{{ $t('forum.actions.NEW_DISCUSSION') }}</button>
                <template v-else>
                    <span class="title">{{editingHeader ? 'Editar tema de debate' : 'Nuevo tema de debate'}}</span>
                    <input v-model="newHeaderModel.subject" type="text" placeholder="Título" maxlength="300">
                    <vue-editor
                    v-model="newHeaderModel.message"
                    :editor-toolbar="customToolbar"
                    :editorOptions="editorSettings"
                    /> 
                    <div class="new-header__actions">
                        <button class="cancel" @click.stop="creatingHeader = false;editingHeader = false;cleanNewHeaderModel();">{{$t('global.DISCARD')}}</button>
                        <button class="confirm" @click.stop="editingHeader ? editHeader() : postHeader()">{{editingHeader ? $t('global.SAVE_CHANGES') : $t('global.PUBLISH')}}</button>
                    </div>
                </template>
            </div>
        </template>

    </div>

</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { inject, computed } from "@vue/runtime-core";
import { VueEditor, Quill } from "vue3-editor";
import Emoji from "quill-emoji/dist/quill-emoji";
import EmptyState from '../../components/EmptyState.vue';
Quill.register("modules/emoji", Emoji);
import Loader from "../../components/Loader.vue";
import { useI18n } from "vue-i18n";

export default {
  components: {
    VueEditor,
    EmptyState,
    Loader
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const formatDate = inject("formatDate");
    const user = computed(() => store.getters.manageUser_user);
    const content = ref();
    const contentLoaded = ref(false);
    const moduleLocked = ref(false);
    const moduleLockedDate = ref();
    const headers = ref();
    const headersLoaded = ref(false);
    const resume = ref();
    const detail = ref({
        expand: false,
        data: []
    });
    const resumeLoaded = ref(false);
    const detailLoaded = ref(false);
    const detailValuesLoaded = ref(false)

    const statusFilters = ref({
        status: ['All'],
        selected: 'All'
    })
    const status = ref(null);


    const newHeaderModel = ref()
    function cleanNewHeaderModel(){
        newHeaderModel.value = {
            targetIdentifier: content.value.identifier,
            subject: '',
            message: '',
        }
    }
    const creatingHeader = ref(false);
    const editingHeader = ref(false);
    const {t} = useI18n()

    async function postHeader(){
        // console.log(newHeaderModel.value.subject.trim().length)
        if(newHeaderModel.value.subject.trim().length <= 1) {
            newHeaderModel.value.subject = '';
            store.dispatch('notifications_create',{text:t('forum.errors.INVALID_TITLE')});
            return
        }
        else{ 
            try {
                let req =  await store.dispatch('forum_postHeader',newHeaderModel.value);
                creatingHeader.value = false;
                cleanNewHeaderModel();
                headers.value.push(req.data)
                store.dispatch('notifications_create', { text: t('forum.CORRECT_NEW_DISCUSSION')});
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('forum.errors.ERROR_POST_NEW_DISCUSSION')});
            }
        }
    }

    function headerEditMode(header){
        newHeaderModel.value.subject = header.subject;
        newHeaderModel.value.message = header.message;
        newHeaderModel.value.id = header.id;
        editingHeader.value = true;
        creatingHeader.value = true;
    }
    async function editHeader(){
        try {
            await store.dispatch('forum_editHeader',newHeaderModel.value);
            editingHeader.value = false;
            creatingHeader.value = false;
            cleanNewHeaderModel();
            getHeaders();
        } catch (error) {
            console.log(error)
            store.dispatch('notifications_create', { text: t('forum.errors.EDIT_HEADER')});
        }
    }

    async function getContent(){
        // contentLoaded.value = false;
        // let reqContent = await store.dispatch("courses_contents", route.params.contentId);
        // content.value = reqContent.data;
        // content.value.data = JSON.parse(content.value.data);
        // content.value.data.Data = content.value.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
        // contentLoaded.value = true;
        try {
            contentLoaded.value = false;
            let reqContent = await store.dispatch("courses_contents", route.params.contentId);
            content.value = reqContent.data;
            content.value.data = JSON.parse(content.value.data);
            content.value.data.Data = content.value.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
            contentLoaded.value = true;
        } catch (error) {
            // alert('error')
            if(error.response.data.includes('Content is not open')){
                moduleLockedDate.value = error.response.data.split('_')[1].split(' ')[0];
                moduleLocked.value = true;
            }
        }
    }
    async function getHeaders(){
        headersLoaded.value = false;
        let reqHeaders = await store.dispatch("forum_forums", content.value.identifier);
        headers.value = reqHeaders.data;
        headersLoaded.value = true;
    }


    /* TUTOR */
    async function getResume(){
      try {
        let req = await store.dispatch('activities_tutorResume',route.params.contentId);
        resume.value = req.data;
        resume.value.expand = true;
        resumeLoaded.value = true;
      } catch (error) {
        console.log(error);
          store.dispatch('notifications_create', { text: t('forum.errors.LOAD_RESUME')});
      }
    }


    async function getDetail(){
        let prop = {
            contentId: route.params.contentId,
            status: statusFilters.value.selected
        }
        try {
            detailValuesLoaded.value = false
            let req = await store.dispatch('activities_tutorDetail',prop);
            detail.value.data = req.data;
            detailValuesLoaded.value = true
            detailLoaded.value = true;
        } catch (error) {
            console.log(error);
            store.dispatch('notifications_create', { text: t('forum.errors.LOAD_DETAIL')});
        }
    }

    const getStatus = async () => {
        let res = await store.dispatch('activities_submissionsFilters')
        statusFilters.value.status.push(...res.data)
    }

    const addStateFilter = (state) => {
        statusFilters.value.selected = state
        document.getElementById('status').checked = false
        getDetail()
    }

    function tutorReq(){
      getResume();
      getDetail();
    }

    onMounted(async() => {
        await getContent();
        await getHeaders();
        getStatus()
        if(user.value.role.toLowerCase() === 'learninguser' && headers.value.length > 0 ) {
            router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${route.params.contentId}/${headers.value[0].id}`)
        }
        cleanNewHeaderModel();
        if (user.value.permissions.includes('CURSO_ACTIVIDAD_AVANCE')){ tutorReq() } 
    });

    return{
        router,
        route,
        formatDate,
        content,
        contentLoaded,
        headers,
        headersLoaded,
        resume,
        detail,
        resumeLoaded,
        detailLoaded,
        user,
        newHeaderModel,
        creatingHeader,
        editingHeader,
        headerEditMode,
        postHeader,
        editHeader,
        cleanNewHeaderModel,
        statusFilters,
        status,
        detailValuesLoaded,
        tutorReq,
        getDetail,
        addStateFilter,
        moduleLocked,
        moduleLockedDate,
        customToolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { color: [] }, { background: [] },],
            ["emoji"]
        ],
        editorSettings: {
            modules: {
            "emoji-toolbar": true,
            "emoji-textarea": false,
            "emoji-shortname": false,
            },
        }
    }
  }
}

</script>

<style src="quill-emoji/dist/quill-emoji.css"></style>
<style lang="scss" scoped>
@import "@/styles/main.scss";

.back-route{
    width: fit-content;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

.content{
    margin: 8px 0 16px 0;
}

.select-header{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, minmax(130px, 1fr));
    gap: 16px;
    overflow-y: auto;
  .title{
    text-align: center;
    font-weight: 600;
    padding-bottom: 8px;
  }
  .item{
    @include flex-column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    &-topic{
        span{
            font-weight: 600;
            color: $green;
            cursor: pointer;
        }
    }
    &-startedBy,&-lastPost{
        @include flex-column;
        span:last-child{
            font-size: 13px;
        }
    }
    &-edit{
        .material-icons{
            font-size: 28px;
            color: $green;
            cursor: pointer;
        }
    }
  }
}

.new-header{
    margin-top: 12px;
    margin-bottom: -12px;
    padding: 12px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    gap: 16px;
    background-color: #F5F5F5;
    position: sticky;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: #fff;
    border-top: 2px solid #eee;
    z-index:99;
    .title{
        font-size: 18px;
        color: $black;
        font-weight: 600;
        align-self: flex-start;
    }
    button{
        padding: 8px 12px;
        background-color: $green;
        color: #fff;
        border-radius: 20px;
        font-weight: 600;
        letter-spacing: 1px;
        font-size: 15px;
    }
    input{
        width: 100%;
        color: $black;
        font-size: 16px;
        font-weight: 500;
        outline: none;
        border: 1px solid $black;
        border-radius: 4px;
        font-family: 'Open Sans', sans-serif; 
        &::placeholder{
            color: $black;
            font-size: 14px;
            font-weight: 500;
        }
        &:focus{
           border: 2px solid $green;
           outline: none;
        }
    }
    input{
        height: 30px;
        padding: 0 8px;
    }
    .quillWrapper{
        width: 100%;
    }
    &__actions{
        padding-top: 8px;
        display: flex;
        justify-content: center;
        gap: 24px;
        button{
            width: 120px;
        }
        .cancel{
            background-color: #fff;
            border: 1px solid $black;
            color: $black;
        }
    }
}

.tutor-view{
    padding-bottom: 24px;
    margin-bottom: 32px;
    //border-bottom: 1px solid #eee;
    .title{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        color: $green;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        &__span{
            display: flex;
            align-items: center;
        }
    }
    .resume,.detail{
        &-data{
            padding: 16px;
            margin-top: 12px;
            background: inherit;
            box-shadow: 0px 4px 4px #00000040;
            border-radius: 8px;
        }
    }

    .detail{
        &-data{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            overflow: auto;
            gap: 16px;
            div{
                @include flex-column;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                margin-bottom: 10px;
                @media screen and (max-width: $bpSmall){
                    font-size: 12px;
                }
            }
            .table-title{
                font-weight: 600;
                FONT-SIZE: 14px;
            }
            .table-user{
                cursor: pointer;
                color: map-get($dark, 800);
                font-weight: 700;
            }
        }
        &__status{
            flex-direction: row;
            span:nth-child(2){
                font-size: 12px;
                font-weight: 400;
                margin-left: 12px;
                @media screen and (max-width: $bpSmall){
                    font-size: 8px;
                }
            }
        }
        &__lastModification{
            color: map-get($dark, 800)
        }
    }
    .resume{
        margin-bottom: 24px;
        &-data{
            display: grid;
            grid-template-columns: auto auto;
            gap: 16px;
            font-weight: 600;
            font-size: 14px;
            overflow-x: auto;
            color: #000;

            span{
                font-weight: 400;
                margin-left: 6px;
            }
        }
    }
}

#emoji-close-div { z-index:0; }

@media screen and (max-width: $bpBig){
.tutor-view{
    .resume-data{
      grid-template-columns: auto;
    }
  }
  .select-header{
    text-align: center;
    .item{
        align-items: center;
    }
}
}



</style>